"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbortReason = exports.PlayerEvent = void 0;
var PlayerEvent;
(function (PlayerEvent) {
    PlayerEvent["DESTROYED"] = "destroyed";
    PlayerEvent["PLAYLIST_INDEX_CHANGED"] = "playlistindexchanged";
    PlayerEvent["PLAYLIST_END"] = "playlistend";
    PlayerEvent["PLAY"] = "play";
    PlayerEvent["PLAYING"] = "playing";
    PlayerEvent["POSITION_CHANGE"] = "positionchange";
    PlayerEvent["PAUSED"] = "paused";
    PlayerEvent["AD_STARTED"] = "adstarted";
    PlayerEvent["AD_IMPRESSION"] = "adimpression";
    PlayerEvent["AD_PLAYING"] = "adplaying";
    PlayerEvent["AD_POSITION_CHANGE"] = "adpositionchange";
    PlayerEvent["AD_PAUSED"] = "adpaused";
    PlayerEvent["AD_ROLL_STARTED"] = "adrollstarted";
    PlayerEvent["AD_ROLL_EMPTY"] = "adrollempty";
    PlayerEvent["AD_ROLL_FINISHED"] = "adrollfinished";
    PlayerEvent["REQUIRE_RECOMMENDATIONS"] = "requirerecommendations";
    PlayerEvent["RECOMMENDATION_SELECTED"] = "recommendationselected";
    PlayerEvent["FULLSCREEN_ENTERED"] = "fullscreenentered";
    PlayerEvent["FULLSCREEN_EXITED"] = "fullscreenexited";
    PlayerEvent["METADATA_RECEIVED"] = "metadatareceived";
    PlayerEvent["SCTE35_RECEIVED"] = "scte35received";
    PlayerEvent["CONTENT_LOADED"] = "contentloaded";
    PlayerEvent["LIVESTREAM_END_DETECTED"] = "livestreamEndDetected";
})(PlayerEvent = exports.PlayerEvent || (exports.PlayerEvent = {}));
var AbortReason;
(function (AbortReason) {
    AbortReason["USERSKIP"] = "userskip";
    AbortReason["DESTROY"] = "destroy";
    AbortReason["PLAYBACK"] = "playbackerror";
    AbortReason["CONTENT_ERROR"] = "contenterror";
    AbortReason["NO_AD_NO_CONTENT"] = "noadnocontent";
    AbortReason["UI_DESTROY"] = "ui-destroy";
})(AbortReason = exports.AbortReason || (exports.AbortReason = {}));
//# sourceMappingURL=api.js.map